/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Slip_Scan_HintInputs */

const vi_cdo_slip_scan_hint = /** @type {(inputs: Cdo_Slip_Scan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét QR để nhận đơn / xác nhận đã giao`)
};

/**

* @param {Cdo_Slip_Scan_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_slip_scan_hint = /** @type {((inputs?: Cdo_Slip_Scan_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Slip_Scan_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_slip_scan_hint(inputs)
});